import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rKiraBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rKiraBilgi>, rKiraBilgi>(
  ActionSubTypes.API_KIRABILGI,
  DefaultInputDataStateModel<pList, rKiraBilgi>()
);
